import { useEffect } from 'react';
import { AppControlData, PreviewItemData } from './types';
import { Mode, tizenMode } from '../../../common/types';
import { useAnalytics } from '../../contexts/AnalyticsContext/useAnalytics';

const hasPreviewPayload = (appControlData: AppControlData): boolean =>
  appControlData.key === 'PAYLOAD';

const getPreviewItemData = (
  appControlData: AppControlData
): PreviewItemData => {
  const actionData = JSON.parse(appControlData.value[0]).values;
  return JSON.parse(actionData) as PreviewItemData;
};

/**
 * Only exported for tests
 */
export const tizenRedirect = (
  setUtmParameters: (id: string) => void
): string | undefined => {
  if (window.tizen) {
    try {
      const requestedAppControl = window.tizen.application
        .getCurrentApplication()
        .getRequestedAppControl();

      if (requestedAppControl) {
        const appControlData = requestedAppControl.appControl.data;

        for (let i = 0; i < appControlData.length; i++) {
          if (hasPreviewPayload(appControlData[i])) {
            const itemData = getPreviewItemData(appControlData[i]);

            if (itemData.v1) {
              const uriParams = /yleareena:\/\/(items|packages)\/([\w-]+)/.exec(
                itemData.v1
              );
              const id = uriParams?.[2];

              if (id?.length) {
                setUtmParameters(id);

                return itemData.v1;
              }
            }
          }
        }
      }
    } catch (e) {
      const message = e instanceof Error ? e.message : e;
      window.elasticApm.captureError(new Error('TizenPreview: ' + message));
    }
  }
};

export const useTizenPreview = (
  mode: Mode,
  setTizenPreview: (deeplink: string) => void
) => {
  const { setUtmParameters } = useAnalytics();

  const setUtmParametersById = (id: string) =>
    setUtmParameters(mode, false, id);

  const tizenRedirectCallback = () => {
    const redirect = tizenRedirect(setUtmParametersById);

    if (!redirect) {
      return;
    }

    setTizenPreview(redirect);
  };

  useEffect(() => {
    if (mode === tizenMode) {
      tizenRedirectCallback();
      window.addEventListener('appcontrol', tizenRedirectCallback);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode]);
};
